import * as React from "react";

const CircleKSimple = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={11}
    viewBox="18 24 70 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="currentColor" d="M78.25,31.73l3.39-4.54h-3.45l-3.12,4.4v-4.4h-2.98v9.48h2.98v-4.33l5.42,6.98c-1.35.81-2.91,1.29-4.61,1.29-4.88,0-8.6-3.73-8.6-8.6s3.73-8.6,8.6-8.6,8.6,3.73,8.6,8.6c0,2.03-.68,3.93-1.76,5.35l-4.47-5.62ZM31.92,27.19h-2.44v9.48h2.44v-9.48ZM37.81,30.65c0,.95-.75,1.42-1.69,1.42h-.68v-2.84h.75c.95,0,1.63.47,1.63,1.42ZM53.05,34.44h3.25v2.24h-5.76v-9.48h2.51v7.25ZM63.41,27.19h-6.23v9.48h6.23v-2.24h-3.79v-1.49h3.59v-2.03h-3.59v-1.49h3.79v-2.24ZM38.42,33.02c.95-.41,1.76-1.29,1.76-2.71,0-2.03-1.42-3.12-4.27-3.12h-3.05v9.48h2.44v-4l2.57,4h2.91l-2.37-3.66ZM24.53,29.22c-1.49,0-2.57,1.22-2.57,2.64s1.08,2.64,2.57,2.64c1.08,0,1.83-.54,2.3-1.35l1.9,1.22c-.88,1.42-2.37,2.3-4.2,2.3-2.91,0-5.01-2.17-5.01-4.88s2.1-4.88,5.01-4.88c1.83,0,3.39.88,4.27,2.3l-1.96,1.29c-.54-.68-1.29-1.29-2.3-1.29ZM43.16,31.86c0-1.42,1.08-2.64,2.57-2.64,1.02,0,1.76.61,2.3,1.29l1.96-1.29c-.88-1.42-2.44-2.3-4.27-2.3-2.91,0-5.01,2.1-5.01,4.88s2.1,4.88,5.01,4.88c1.83,0,3.32-.88,4.2-2.3l-1.9-1.22c-.47.81-1.22,1.35-2.3,1.35-1.49,0-2.57-1.22-2.57-2.64Z"/>
  </svg>
);

export default CircleKSimple;
